import { AuthenticationLogList } from '../../../components/Report';

export function FailedAuthentication() {
  return <AuthenticationLogList mode="failedAuthentication" />;
}
